import React from 'react';
import logoIcon from '../../assets/icons/MeinGruenraum_Logo.png';
import { reload } from '../../utils/browserNav';

class AppCrash extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, showDetails: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidMount() {
    // E2E test hook: allows Playwright to force the error boundary into its
    // error state without needing a real render-time exception.
    // Only registered outside of production builds.
    if (process.env.NODE_ENV !== 'production') {
      window.__e2eForceAppCrash = () => {
        this.setState({ hasError: true, error: new Error('E2E test crash') });
      };
    }
  }

  componentWillUnmount() {
    if (process.env.NODE_ENV !== 'production') {
      delete window.__e2eForceAppCrash;
    }
  }

  componentDidCatch(error, info) {
    console.error('[AppCrash]', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const { error, showDetails } = this.state;

    return (
      <div
        data-testid="app-crash-ui"
        className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4"
      >
        <div className="w-full max-w-sm bg-white rounded-2xl border border-gray-200 p-6 text-center">
          <img
            src={logoIcon}
            alt="Mein Grünraum"
            className="h-12 w-12 mx-auto mb-4 object-contain"
          />
          <h1 className="text-xl font-bold text-gray-900 mb-2">
            Etwas ist schiefgelaufen.
          </h1>
          <p className="text-sm text-gray-500 mb-6">
            Die App konnte nicht geladen werden. Versuche es erneut.
          </p>
          <button
            data-testid="app-crash-reload-btn"
            onClick={reload}
            className="w-full bg-emerald-600 text-white text-sm py-2 rounded-lg hover:bg-emerald-700 transition-colors"
          >
            App neu laden
          </button>
          {error && (
            <div className="mt-4 text-left">
              <button
                onClick={() => this.setState((s) => ({ showDetails: !s.showDetails }))}
                className="text-xs text-gray-400 hover:underline"
              >
                {showDetails ? '▲ Details verbergen' : '▼ Details anzeigen'}
              </button>
              {showDetails && (
                <pre className="mt-2 text-xs text-gray-500 overflow-auto max-h-32 bg-gray-50 rounded p-2 whitespace-pre-wrap break-words">
                  {error.message}
                </pre>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default AppCrash;
